import routes from "@/routes";
import { currentUser } from "@/core/users/session";
import { currentUserHasAnyRole } from "@/core/users/roles";
const HIDDEN_REGION_CODES_ADVANCED = ["N100", "N300", "E100", "E200", "E300", "S300", "C100"];
const HIDDEN_REGION_CODES_RESULTS = [];
const HIDDEN_REGION_CODES_OBJECTIVES = ["E300"];
const CASTILLA_ALLOWED_ROLES_ADVANCED = ["Gerente Distribucion", "Jefe de Distribucion", "Supervisor del Distribuidor"];
export default {
    name: 'Header',
    methods: {
        active() {
            this.$emit('active');
        },
    },
    data() {
        return {
            isActive: false,
            routes: routes,
        };
    },
    watch: {
        $route(to, from) {
            this.isActive = false;
        }
    },
    computed: {
        headerRoutes() {
            var _a, _b, _c;
            const user = currentUser();
            const isNorthReadonlyUser = user.area_code === "N" && !user.region_code;
            const isRestrictedUserAdvanced = HIDDEN_REGION_CODES_ADVANCED.includes((_a = user.region_code) !== null && _a !== void 0 ? _a : "");
            const isRestrictedUserResults = HIDDEN_REGION_CODES_RESULTS.includes((_b = user.region_code) !== null && _b !== void 0 ? _b : "");
            const isRestrictedUserObjectives = HIDDEN_REGION_CODES_OBJECTIVES.includes((_c = user.region_code) !== null && _c !== void 0 ? _c : "");
            const isCastillaWithoutAdvancedRole = user.region_code === "C200" && !currentUserHasAnyRole(CASTILLA_ALLOWED_ROLES_ADVANCED);
            return this.routes.filter(route => {
                if (route.type !== 'header-nav')
                    return false;
                if ((isRestrictedUserAdvanced || isNorthReadonlyUser || isCastillaWithoutAdvancedRole) && route.name === 'advanced-report')
                    return false;
                if (isRestrictedUserResults && route.name === 'results-report')
                    return false;
                if (isRestrictedUserObjectives && route.name === 'objectives-report')
                    return false;
                return true;
            });
        }
    }
};
